// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  // Image reveal animations
  const revealImages = document.querySelectorAll<HTMLElement>('[data-reveal]')
  if (revealImages?.length) {
    import('./modules/image-reveal').then(({ default: init }) => {
      init(revealImages)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const mobileMenuWrapper = document.querySelectorAll('.mobileMenuWrapper')
if (mobileMenuWrapper && mobileMenuWrapper !== null) {
  mobileMenuWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const menuButtonWrapper = document.querySelectorAll('.menuButtonWrapper')
if (menuButtonWrapper && menuButtonWrapper !== null) {
  menuButtonWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

// Logo switcher for mobile menu
const logoDefault = document.querySelector('[data-logo-default]')
const logoMenu = document.querySelector('[data-logo-menu]')

if (logoDefault && logoMenu) {
  const observer = new MutationObserver(() => {
    const isMenuOpen = document.body.classList.contains('menu-open')
    logoDefault.classList.toggle('opacity-0', isMenuOpen)
    logoDefault.classList.toggle('opacity-100', !isMenuOpen)
    logoMenu.classList.toggle('opacity-100', isMenuOpen)
    logoMenu.classList.toggle('opacity-0', !isMenuOpen)
  })

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  })
}

// Sticky header that hides on scroll down and shows on scroll up
const initStickyHeader = () => {
  const header = document.getElementById('site-header')
  if (!header) {
    return
  }

  let lastScrollY = window.scrollY
  let ticking = false
  let isHeaderElementFocused = false

  const updateHeader = () => {
    if (document.body.classList.contains('menu-open')) {
      ticking = false
      return
    }

    const currentScrollY = window.scrollY
    const isScrollingUp = currentScrollY < lastScrollY
    const isAtTop = currentScrollY <= 10

    if (isHeaderElementFocused || isAtTop) {
      header.classList.add('header-visible')
      header.classList.remove('header-hidden')
    } else if (isScrollingUp) {
      header.classList.add('header-visible')
      header.classList.remove('header-hidden')
    } else {
      header.classList.remove('header-visible')
      header.classList.add('header-hidden')
    }

    lastScrollY = currentScrollY
    ticking = false
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateHeader)
      ticking = true
    }
  })

  document.addEventListener('focusin', (e) => {
    const target = e.target as HTMLElement
    if (header.contains(target)) {
      isHeaderElementFocused = true
      header.classList.add('header-visible')
      header.classList.remove('header-hidden')
    }
  })

  document.addEventListener('focusout', (e) => {
    const target = e.target as HTMLElement
    if (header.contains(target)) {
      isHeaderElementFocused = false
      if (!ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }
  })

  updateHeader()
}

initStickyHeader()
